import React from 'react';
import s from './QlfcLevelsTable.module.css';
import {QlfcnamesType, QlfcLevelsType, ResponsQLFCType, TotalQLFCType} from '../../../types/TypesUser';
import {formatNumber} from '../../../assets/utils/utils';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';
import {ValuesRequestTeamType} from '../../../types/TypesPage';
import {userQualifications} from '../../../assets/utils/translatersFunc';

type Props = {
    data: ResponsQLFCType;
    month: string;
};

const QlfcLevelsTable: React.FC<Props> = ({data, month}) => {
    const {t} = useTranslation();
    const navigate = useNavigate();
    const headers: QlfcnamesType[] = data.qlfcnames || [];
    const levels: QlfcLevelsType[] = data.levels || [];
    const totalsByQlfc: TotalQLFCType[] = data.total_qlfc || [];
    const grandTotal = Number(data.total || 0);

    const handleCellClick = (levelLabel: string, qlfcValue: string) => {
        // Преобразуем levelLabel в число
        const levelNumber = parseInt(levelLabel, 10);
        
        const defaultFilters: ValuesRequestTeamType = {
            month,
            non_filter: false,
            // Передаем число. Для уровней <= 6 отметки поставится в фильтре,
            // для уровней > 6 отметки не поставятся (так как в фильтре только 1-6),
            // но фильтрация по уровню будет работать
            levels: !isNaN(levelNumber) ? levelNumber : undefined,
            qlfcnames: qlfcValue,
        };

        navigate('/my_team', {
            state: {
                defaultFilters,
            },
        });
    };

    return (
        <div className={s.container}>
            <div className={s.table}>
                <div className={s.header}>
                    <div className={s.hLevel}>{t('Рівень')}</div>
                    {headers.map((h) => {
                        const qlfc = userQualifications.find((q) => q.value === h.qlfc);
                        return (
                            <div 
                                key={h.qlfc} 
                                className={s.hName} 
                                title={h.qlfcname}
                                style={{
                                    background: qlfc?.background || 'transparent',
                                    color: qlfc?.background ? 'white' : 'inherit',
                                }}
                            >
                                {h.qlfc}
                            </div>
                        );
                    })}
                    <div className={s.hTotal}>{t('Всього')}</div>
                </div>

                <div className={s.body}>
                    {levels.map((row) => (
                        <div key={row.level} className={s.row}>
                            <div className={s.cellLevel}>{row.level}</div>
                            {row.qlfc_count.map((c, idx) => {
                                const qlfcValue = headers[idx]?.qlfc || '';
                                return (
                                    <button
                                        key={`${row.level}-${idx}`}
                                        type="button"
                                        className={s.cell}
                                        onClick={() => handleCellClick(row.level, qlfcValue)}
                                        title={`${t('Рівень')} ${row.level} ${c.name}`}
                                    >
                                        {formatNumber(Number(c.count || 0))}
                                    </button>
                                );
                            })}
                            <div className={s.cellTotal}>{formatNumber(Number(row.total_count || 0))}</div>
                        </div>
                    ))}
                </div>

                <div className={s.footer}>
                    <div className={s.fLabel}>{t('Всього')}</div>
                    {totalsByQlfc.map((tq) => (
                        <div key={tq.qlfc} className={s.fCell}>{formatNumber(Number(tq.total_count || 0))}</div>
                    ))}
                    <div className={s.fGrand}>{formatNumber(grandTotal)}</div>
                </div>
            </div>
        </div>
    );
};

export default QlfcLevelsTable;


